import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import SavedTabs from "./SavedTabs";
import SavedSummary from "./SavedSummary";
import SavedErrorDetails from "./SavedErrorDetails";
import SavedRuleCatalogue from "./SavedRuleCatalogue";
import { Box } from "@mui/material";
import "./DataProductSave.css";

const SavedDataProduct = () => {
  const { dashboardId } = useParams();   // ✅ only dashboardId now
  const [searchParams, setSearchParams] = useSearchParams();

  const tabFromUrl = searchParams.get("tab") || "Summary";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [pivotGrouping, setPivotGrouping] = useState({});

  // ✅ No Save/Share → just fetch filters from GET response
  const handleFiltersChange = (newFilters) => {
    if (newFilters.pivot_grouping) {
      setPivotGrouping(newFilters.pivot_grouping);
      return;
    }
    if (
      newFilters &&
      Object.keys(newFilters).length === 0 &&
      newFilters.constructor === Object
    ) {
      setFilters({});
      return;
    }

    setFilters({ ...(newFilters || {}) });
  };

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  return (
    <Box sx={{ padding: 0 }}>
      <div className="dashboard-dashboard poppins-regular">
        <SavedTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          hideActions={true}   // custom prop to hide Save/Share
        />

        <div
          className="tab-content-tab"
          style={{ background: "#F7F7F7", padding: "28px" }}
        >
          {activeTab === "Summary" && (
            <SavedSummary
              dashboardId={dashboardId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}

          {activeTab === "Error Details" && (
            <SavedErrorDetails
              dashboardId={dashboardId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}

          {activeTab === "Rule Catalogue" && (
            <SavedRuleCatalogue
              dashboardId={dashboardId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}
        </div>
      </div>
    </Box>
  );
};

export default SavedDataProduct;
